<template>
  <section id="intro-text" class="intro-text page">
    <h1>Prints voor professionals</h1>
    <p>
      Als full service grafisch dienstverlener levert Koninklijke Rijnja groot-
      en kleinformaat printproducten door heel Nederland.
    </p>
    <p>
      Bij ons kunt u rekenen op kwaliteit én gemak. Wij denken met u mee en
      zorgen ervoor dat u geen omkijken meer hebt naar uw printopdrachten.
      Rijnja regelt het.
    </p>
    <ul>
      <li>Klik & klaar bestelproces op de website</li>
      <li>Persoonlijk contact via één aanspreekpunt</li>
      <li>
        Uiterlijk de volgende werkdag met eigen koeriers bezorgd door heel
        Nederland
      </li>
      <li>
        Gecertificeerd in kwaliteits- en milieumanagement en
        informatiebeveiliging
      </li>
    </ul>
    <rijnja-regelt-het
      class="rrr pointer"
      @click.native="$router.push({ name: 'contact' })"
    ></rijnja-regelt-het>
  </section>
</template>

<script>
import RijnjaRegeltHet from './RijnjaRegeltHet.vue'

export default {
  components: { RijnjaRegeltHet }
}
</script>

<style lang="scss" scoped>
.intro-text {
  width: 100%;
  padding: 549px 20px 10px;
  position: relative;

  ul {
    padding-left: 16px;
    list-style-position: outside;
  }
}

.rrr {
  width: 121px;
  margin: 30px auto;
}

@media only screen and (min-width: 375px) {
  .intro-text {
    padding-top: 635px;
  }
}
@media only screen and (min-width: 480px) {
  .intro-text {
    padding: 635px 32px 32px 32px;
  }
}

@media only screen and (min-width: 620px) {
  .intro-text {
    padding-top: 660px;
  }
}

@media only screen and (min-width: 768px) {
  .intro-text {
    padding: 0px;
    max-width: 280px;
    right: 40px;
    position: absolute;
    padding-top: max(calc(50vh - 230px), 117px);
    width: 33%;

    ul {
      list-style-position: outside;
      padding-left: 0px;
    }
  }
}

@media only screen and (min-width: 900px) {
  .intro-text {
    //padding-top: 170px;
  }
}

@media only screen and (min-width: 1024px) {
  .intro-text {
    padding-top: max(50vh - 330px, 216px);
    //    padding-top: max(50vh - 240px, 117px);
    right: 40px;
  }
}
</style>
